package one.healthium.profile.ui.food.models

import one.healthium.base.utils.toString
import one.healthium.domain.common.FoodUnit

sealed interface Units {
    val displayValue: String
    val gramValue: Float
    val isFloating: Boolean

    fun format(value: Float) = when (this) {
        else -> "${value.toString(2)} $displayValue"
    }

    object Gram : Units {
        override val displayValue: String
            get() = "g"
        override val gramValue: Float
            get() = 1f
        override val isFloating = false
    }

    object Ml : Units {
        override val displayValue: String
            get() = "ml"
        override val gramValue: Float
            get() = 1f
        override val isFloating = false
    }

    object Oz : Units {
        override val displayValue: String
            get() = "oz."
        override val gramValue: Float
            get() = 28.3495f
        override val isFloating = true
    }

    object FlOz : Units {
        override val displayValue: String
            get() = "fl. oz."
        override val gramValue: Float
            get() = 29.5735f
        override val isFloating = true
    }

    data class Tablespoon(
        override val gramValue: Float
    ) : Units {
        override val displayValue: String
            get() = "tbsp"
        override val isFloating = true
    }

    data class Teaspoon(
        override val gramValue: Float
    ) : Units {
        override val displayValue: String
            get() = "tsp"
        override val isFloating = true
    }

    data class Cup(
        override val gramValue: Float
    ) : Units {
        override val displayValue: String
            get() = "cups"
        override val isFloating = true
    }

    data class Piece(
        override val gramValue: Float
    ) : Units {
        override val displayValue: String
            get() = "piece (s)"
        override val isFloating = true
    }

    data class Portion(
        override val gramValue: Float
    ) : Units {
        override val displayValue: String
            get() = "meals"
        override val isFloating = true
    }
}

fun Units.toFoodUnit(): FoodUnit {
    return when (this) {
        is Units.Cup -> FoodUnit.Cup
        Units.FlOz -> FoodUnit.FlOz
        Units.Gram -> FoodUnit.Gram
        Units.Ml -> FoodUnit.Ml
        Units.Oz -> FoodUnit.Oz
        is Units.Piece -> FoodUnit.Piece
        is Units.Tablespoon -> FoodUnit.Tablespoon
        is Units.Teaspoon -> FoodUnit.Teaspoon
        is Units.Portion -> FoodUnit.Portion
    }
}
